import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/changes/license.changes.query.gql"
import type {
  FeatureSurfaceChangesQuery,
  FeatureSurfaceChangesQueryVariables,
} from "@/v2-backoffice-client/license/changes/__types__/license.changes.query"

type Options = QueryHookOptions<
  FeatureSurfaceChangesQuery,
  FeatureSurfaceChangesQueryVariables
>

export function useFeatureSurfaceChangesQuery(options?: Options) {
  return useQuery<
    FeatureSurfaceChangesQuery,
    FeatureSurfaceChangesQueryVariables
  >(query, options)
}
